function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sendAnalyticsEvent = require('./sendAnalyticsEvent');
var defaultConfig = require('./defaultConfig');
var extractLinkAttributes = require('./extractLinkAttributes');
var standardisedClickTracking = function standardisedClickTracking(event) {
  var _element$closest, _element$closest2;
  var customConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = _objectSpread(_objectSpread({}, defaultConfig), customConfig);
  // Find out if this click event has an element we want to track.
  // Try the clicked element first, then look for any parent elements that might be trackable.
  var element = [event.target, event.target.closest('a, [data-analytics-click-label]')].find(isElementTrackable);

  // If the element that was clicked is not something we want to track, return early.
  if (!element) return;
  var linkAttributes = extractLinkAttributes(element, config);

  // See the GA4 Event Attributes Catalogue for a description of these attributes:
  // https://www.notion.so/853a20e4ed93407481bd68dc0ba27741?v=dfcbd9e925d24db5bb1e14172b9dbbba
  var attributes = _objectSpread(_objectSpread({
    eventName: 'internal_click',
    // This may be overridden by linkAttributes below depending on the link URL.
    context: (_element$closest = element.closest('[data-analytics-context]')) === null || _element$closest === void 0 ? void 0 : _element$closest.dataset.analyticsContext,
    contextDetail: (_element$closest2 = element.closest('[data-analytics-context-detail]')) === null || _element$closest2 === void 0 ? void 0 : _element$closest2.dataset.analyticsContextDetail,
    clickLabel: extractClickLabel(element),
    clickType: element.tagName
  }, linkAttributes), {}, {
    customConfig: customConfig
  });
  sendAnalyticsEvent(attributes);
};
var extractClickLabel = function extractClickLabel(element) {
  var _element$textContent, _element$attributes$t, _element$attributes$a, _element$attributes$a2;
  return [element.dataset.analyticsClickLabel, (_element$textContent = element.textContent) === null || _element$textContent === void 0 ? void 0 : _element$textContent.trim(), (_element$attributes$t = element.attributes.title) === null || _element$attributes$t === void 0 ? void 0 : _element$attributes$t.value.trim(), (_element$attributes$a = element.attributes['aria-label']) === null || _element$attributes$a === void 0 ? void 0 : _element$attributes$a.value.trim(), (_element$attributes$a2 = element.attributes.alt) === null || _element$attributes$a2 === void 0 ? void 0 : _element$attributes$a2.value.trim()].find(Boolean);
};
var isElementTrackable = function isElementTrackable(element) {
  // Handle undefined/null
  if (!element) return false;

  // Make it possible for elements with their own custom tracking code to opt-out of these standardised events
  // by setting a `data-analytics-has-custom-tracking="true"` attribute on either the element or a parent element
  if (element.closest('[data-analytics-has-custom-tracking="true"]')) return false;

  // All links should be trackable
  if (element.tagName === 'A') {
    var _element$attributes$h;
    var elementHref = (_element$attributes$h = element.attributes.href) === null || _element$attributes$h === void 0 ? void 0 : _element$attributes$h.value.trim();
    if (!elementHref) return false; // unless their href is missing or empty

    if (isBlockedHref(elementHref)) return false;
    return true;
  }

  // Any element with a data-analytics-click-label attribute is trackable
  if (element.dataset.analyticsClickLabel !== undefined) return true;

  // Otherwise this is some other element we don't care about tracking.
  return false;
};
var matchHrefToString = function matchHrefToString(str) {
  return function (href) {
    return href === str;
  };
};
var matchHrefToRegexp = function matchHrefToRegexp(re) {
  return function (href) {
    return re.test(href);
  };
};
var hrefBlockList = [matchHrefToString('#'), matchHrefToRegexp(/^javascript:/)];
var isBlockedHref = function isBlockedHref(href) {
  return hrefBlockList.some(function (checkFunction) {
    return checkFunction(href);
  });
};
module.exports = standardisedClickTracking;